module.exports = __webpack_public_path__ + "static/media/3_4.2bd33936.png";